import { useState, useEffect, useCallback, useMemo } from "react"

const useTransferForm = (selectedToken) => {
  const [amount, setAmount] = useState("")
  const [recipientAddress, setRecipientAddress] = useState("")
  const [useMaxAmount, setUseMaxAmount] = useState(true)

  // Initialize amount when token changes or useMaxAmount is toggled
  useEffect(() => {
    if (selectedToken && useMaxAmount) {
      setAmount(selectedToken.balance || "0")
    }
  }, [selectedToken, useMaxAmount])

  const handleAmountChange = useCallback((e) => {
    setAmount(e.target.value)
    setUseMaxAmount(false)
  }, [])

  const handleMaxClick = useCallback(() => {
    if (selectedToken) {
      setAmount(selectedToken.balance || "0")
      setUseMaxAmount(true)
    }
  }, [selectedToken])

  const handleRecipientChange = useCallback((e) => {
    setRecipientAddress(e.target.value)
  }, [])

  // Validation errors
  const validationErrors = useMemo(() => {
    const errors = {}
    const numAmount = parseFloat(amount)
    const maxBalance = parseFloat(selectedToken?.balance || 0)

    if (!amount || amount === "") {
      errors.amount = "Amount is required"
    } else if (numAmount > maxBalance) {
      errors.amount = "Amount exceeds available balance"
    } else if (numAmount <= 0) {
      errors.amount = "Amount must be greater than 0"
    }

    if (!recipientAddress || recipientAddress.trim() === "") {
      errors.recipient = "Recipient address is required"
    } else if (recipientAddress.includes(" ")) {
      errors.recipient = "Space is not allowed"
    } else if (!recipientAddress.startsWith("0zk")) {
      errors.recipient = "Invalid Railgun address format (must start with 0zk)"
    } else if (recipientAddress.length < 40) {
      errors.recipient = "Address is too short"
    }

    return errors
  }, [amount, recipientAddress, selectedToken?.balance])

  // Form validation
  const isValidForm = useMemo(() => {
    const numAmount = parseFloat(amount)
    const maxBalance = parseFloat(selectedToken?.balance || 0)

    return amount &&
      recipientAddress &&
      numAmount > 0 &&
      numAmount <= maxBalance &&
      recipientAddress.trim().length > 0 &&
      Object.keys(validationErrors).length === 0
  }, [amount, recipientAddress, selectedToken?.balance, validationErrors])

  return {
    amount,
    recipientAddress,
    useMaxAmount,
    isValidForm,
    validationErrors,
    handleAmountChange,
    handleMaxClick,
    handleRecipientChange
  }
}

export default useTransferForm